module.exports = __webpack_public_path__ + "static/media/alarm-clock.85fc0727.svg";